// export default function Page(){
//   return (
//     <div className="page">
//       <h1>Security Service 1</h1>
//       <p>Dummy content for Security Service 1.</p>
//       <img src="https://via.placeholder.com/800x300" alt="dummy"/>
//     </div>
//   );
// }

import React from "react";
import "../../styles/security.css";
import Securitysolutionss from "../../assets/images/securitysolutions.jpg";
import eventsecurity from "../../assets/images/event-security.jpg";
import securityImg from "../../assets/images/security.jpg";
import DogHandler from "../../assets/images/Dog-Handler.jpg";
import CloseProtection from "../../assets/images/Close-Protection.jpg";
import DoorSupervisor from "../../assets/images/doors-supervisors.jpg";
import CCTVMonitoring from "../../assets/images/CCTV-Monitoring.jpg";
import VacantProperty from "../../assets/images/Vacant-Property.jpg";

// CCTV Monitoring
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
const services = [
  {
    id: "door-supervisor",
    title: "Door Supervisor",
    text: "Our Door Supervisors are the first line of defence for your premises, representing both security and professionalism. At COLIPS, we carefully select and train our staff to manage access control, verify identification, and maintain a safe environment at all times. Our supervisors are skilled in conflict management, ensuring situations are handled calmly and effectively before they escalate. They work closely with venue management to enforce policies while maintaining a welcoming atmosphere. With a strong focus on vigilance and customer interaction, our Door Supervisors help protect your people, property, and reputation.",
    image: DoorSupervisor,
  },
  {
    id: "event-security",
    title: "Event Security",
    text: "COLIPS provides comprehensive event security services designed to protect guests, staff, and assets throughout your event. From initial planning and risk assessments to on-the-ground execution, we ensure every detail is covered. Our teams manage crowd control, entry points, and emergency response with precision and professionalism. We adapt our security plans to suit events of all sizes, from private functions to large public gatherings. By combining visible deterrence with discreet monitoring, we create a secure environment that allows your event to run smoothly and safely.",
    image: eventsecurity,
  },
  {
    id: "close-protection",
    title: "Close Protection",
    text: "Our close protection service provides discreet and professional personal security for individuals who require enhanced safety. Trained specialists assess potential risks and implement effective protection strategies tailored to each situation. Whether for business executives, public figures, or high-risk travel, our team ensures constant vigilance. We prioritize confidentiality, professionalism, and minimal disruption to daily activities. Advanced planning and situational awareness help prevent potential threats. Our focus is on providing peace of mind through reliable personal protection.",
    image: CloseProtection,
  },
  {
    id: "dog-handler",
    title: "Dog Handler",
    text: "COLIPS Dog Handler services provide an enhanced level of security through highly trained handlers and licensed security dogs. This service is ideal for large sites, industrial areas, and locations requiring strong visible deterrence. Our dog teams conduct patrols, perimeter checks, and rapid response operations with exceptional effectiveness. The presence of a dog unit significantly reduces the risk of intrusion and criminal activity. With strict training standards and controlled handling, we ensure safety, compliance, and maximum protection at all times.",
    image: DogHandler,
  },
  {
    id: "cctv-monitoring",
    title: "CCTV Monitoring",
    text: "Our CCTV Monitoring services deliver round-the-clock surveillance to safeguard your premises. COLIPS uses advanced monitoring systems operated by trained professionals who can quickly identify and respond to suspicious activity. We provide real-time observation, incident reporting, and coordination with on-site security or emergency services when required. This proactive approach helps prevent incidents before they occur. By combining technology with human expertise, we ensure continuous protection and reliable oversight of your property.",
    image: CCTVMonitoring,
  },
  {
    id: "vacant-property",
    title: "Vacant Property Management",
    text: "COLIPS offers specialist Vacant Property Management to protect unoccupied buildings from theft, vandalism, and unauthorised access. Our services include regular inspections, security patrols, access control, and alarm response. We assess each property’s risk profile and implement tailored security measures to maintain its condition and safety. By maintaining a visible security presence, we help deter criminal activity and reduce insurance risks. Our proactive management ensures your vacant property remains secure, compliant, and well-protected at all times.",
    image: VacantProperty,
  },
];

const Security = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);
  return (
    <div className="security-page">
      {/* HERO */}
      <section className="security-hero">
        <div className="security-hero-left">
          <h1>Tailored Security Solutions Across the UK</h1>
          <p>
            At COLIPS, we deliver reliable and adaptable security solutions
            designed to meet the diverse needs of businesses, events, and
            private clients across the UK. Our approach combines experienced
            personnel, modern security practices, and a deep understanding of
            risk management. We focus on prevention, professionalism, and rapid
            response to ensure complete peace of mind.
          </p>

          <a href="/contact" className="sec-btn">
            Get In Touch
          </a>
        </div>

        <div className="security-hero-right">
          <img src={Securitysolutionss} alt="Security" />
        </div>
      </section>

      {/* SERVICES LIST */}
      {services.map((service, index) => (
        <section
          id={service.id}
          key={index}
          className={`security-section ${index % 2 === 0 ? "" : "reverse"}`}
        >
          <div className="security-image">
            <img src={service.image} alt={service.title} />
          </div>

          <div className="security-content">
            <h2>{service.title}</h2>
            <p>{service.text}</p>
          </div>
        </section>
      ))}

      {/* CTA */}
      <section className="security-cta">
        <div className="security-cta-content">
          {/* <h2>
            At COLIPS, we understand that no two security needs are the same.
            Whether you require manned guarding, event security, close
            protection, or full property management, our experienced team is
            ready to deliver a solution tailored to you. Get in touch with us
            today to discuss your requirements and discover how our reliable,
            professional security services can protect your people, assets, and
            premises across the UK.
          </h2> */}
          <p>
            At COLIPS, we understand that no two security needs are the same.
            Whether you require manned guarding, event security, close
            protection, or full property management, our experienced team is
            ready to deliver a solution tailored to you. Get in touch with us
            today to discuss your requirements and discover how our reliable,
            professional security services can protect your people, assets, and
            premises across the UK.
          </p>

          {/* <a href="/contact" className="sec-btn">
            CONTACT NOW
          </a> */}
        </div>
      </section>
    </div>
  );
};

export default Security;
